import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonRadioGroup } from './RadioGroup.definition';
import { chameleonRadioButton } from '../RadioButton/RadioButton.definition';
import { chameleonTypography } from '../Typography/Typography.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }), chameleonRadioGroup({ prefix }), chameleonRadioButton({ prefix }));
}
